import { Header } from '../components/Header';
import { Footer } from '../components/Footer';

export default function About() {
  return (
    <div className="min-h-screen bg-gray-50" dir="rtl">
      <Header />

      {/* Hero Section */}
      <section className="bg-gradient-to-r from-[#D4AF37] to-[#B8960C] text-white py-20">
        <div className="container mx-auto px-4">
          <div className="text-center">
            <h1 className="text-4xl md:text-5xl font-bold mb-4">أبو زهرة للعقارات</h1>
            <p className="text-xl text-white/90">خبرة أكتر من 10 سنين في السوق العقاري بنساعدك تلاقي المكان المناسب ليك بأفضل اختيار وأقل مجهود.</p>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <div className="bg-white rounded-lg shadow-lg p-8 mb-8">
              <div className="text-right" dir="rtl">
                <h2 className="text-2xl font-bold text-[#8B7109] mb-4">أبو زهرة للعقارات</h2>
                <p className="text-gray-700 mb-4 leading-relaxed text-lg">
                  خبرة أكتر من 10 سنين في السوق العقاري بنساعدك تلاقي المكان المناسب ليك بأفضل اختيار وأقل مجهود.
                </p>
                <p className="text-gray-700 mb-4 leading-relaxed text-lg">
                  بنقدم خدمات بيع وشراء وتأجير العقارات (شقق – أراضي – مباني).
                </p>
                <p className="text-gray-700 mb-4 leading-relaxed text-lg">
                  فاهمين إن اختيار العقار مش سهل عشان كده بنركز على إننا نوفرلك اختيارات مناسبة و بنكون معاك خطوة بخطوة لحد ما توصل لأفضل اختيار ليك
                </p>
                <p className="text-gray-700 mb-4 leading-relaxed text-lg font-semibold">
                  هدفنا إنك تلاقي المكان اللي يناسب احتياجاتك و يكون استثمارك فيه صح
                </p>
              </div>
            </div>

            {/* Contact Information */}
            <div className="bg-[#D4AF37] rounded-lg shadow-lg p-8 text-white">
              <h3 className="text-2xl font-bold mb-6 text-center">معلومات التواصل</h3>
              <div className="space-y-4 text-right" dir="rtl">
                <p className="text-xl">
                  <strong>المكان:</strong> أول أبو عطوة – بجوار جامع التوبه
                </p>
                <p className="text-xl">
                  <strong>للتواصل:</strong> 01009338043
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
